import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PdfToWordPage = lazy(() => import('../pages/pdf-to-word/page'));
const PdfToExcelPage = lazy(() => import('../pages/pdf-to-excel/page'));
const PdfToPptPage = lazy(() => import('../pages/pdf-to-ppt/page'));
const ImageConvertPage = lazy(() => import('../pages/image-convert/page'));
const PdfToolsPage = lazy(() => import('../pages/pdf-tools/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const TutorialsPage = lazy(() => import('../pages/tutorials/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/pdf-to-word',
    element: <PdfToWordPage />
  },
  {
    path: '/pdf-to-excel',
    element: <PdfToExcelPage />
  },
  {
    path: '/pdf-to-ppt',
    element: <PdfToPptPage />
  },
  {
    path: '/image-convert',
    element: <ImageConvertPage />
  },
  {
    path: '/pdf-tools',
    element: <PdfToolsPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/tutorials',
    element: <TutorialsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;